module.exports = __webpack_public_path__ + "img/josef-salvat.b8cc351e.jpg";